import React from 'react'
import { observer } from 'mobx-react'
import I18nInput from './i18n'

const FilmAttrI18nInput = ({ store, attrs, platform, name, ...rest }) => {
  function attrFilter (attr) {
    return attr.platform === platform && attr.name === name
  }

  function updateField (lang, val) {
    // add to language tab
    if (store && store.cv && store.cv.attributes) {
      const params = {
        attribute_id: name,
        attribute_name_flyprivate: (name === 'desc' ? 'long_synopsis' : (name === 'shortdesc' ? 'short_synopsis' : 'distribution_title')),
        attribute_name_internal: name,
        attribute_value: val,
        language: lang,
        metadata_type: 'attributes'
      }
      const tempAttr = store.cv.attributes.find(j =>
        j.metadata_type === params.metadata_type &&
        j.language === lang &&
        j.attribute_id === params.attribute_id &&
        j.attribute_name_internal === params.attribute_name_internal)

      if (!tempAttr) {
        store.cv.attributes.push(Object.assign({}, params))
      } else {
        tempAttr.attribute_value = params.attribute_value
      }
    }
    // update attribute
    store.changeAttrArrayValue('attrs', { platform, name, lang }, val)
  }

  function onAdd (lang) {
    store.addArrayRow('attrs', { platform, name, lang, value: '' })
  }

  function onRemove (row) {
    store.removeArrayRow('attrs', row)
  }

  return <I18nInput {...rest} store={store}
    attrFilter={attrFilter} attrs={attrs} name={name}
    onAdd={onAdd} onRemove={onRemove} onChange={updateField} />
}

export default observer(FilmAttrI18nInput)
